import React from 'react';
import {
    Segment,
    Image,
    Table,
    Loader
} from 'semantic-ui-react';
import _ from 'lodash';
import Moment from 'moment';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ClaimImageDisplayReceipt = (props) => {
    return (
        <div>
            {
                _.map(props.receipts, (receipt) => {
                    const {
                        id,
                        viewUrl,
                        visit_type,
                        date_incurred,
                        data_incurred_to,
                        hospital_name,
                        receipt_no,
                        receipt_amount,
                        attachment_token,
                        loadingFileUrl,
                        fileUrl
                    } = receipt
                    return (
                        <Segment key={id}>
                            <Table>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            {attachment_token ?
                                                loadingFileUrl ?
                                                    (
                                                        <Loader active size='small' inline></Loader>
                                                    )
                                                    :
                                                    fileUrl ?
                                                        (
                                                            <a href={fileUrl} target="_blank">
                                                                Open File
                                                            </a>
                                                        )
                                                        :
                                                        (
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    MySwal.fire({
                                                                        icon: "error",
                                                                        title: "Error",
                                                                        text: "Unable to open!",
                                                                    });
                                                                }}
                                                            >
                                                                Open File
                                                            </a>
                                                        )
                                                :
                                                (
                                                    <a href={viewUrl} target="_blank">
                                                        Open File
                                                    </a>
                                                )
                                            }
                                        </Table.Cell>
                                        <Table.Cell>
                                            {visit_type}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {Moment(date_incurred).format('DD-MM-YYYY')} - {Moment(data_incurred_to).format('DD-MM-YYYY')}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {hospital_name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {receipt_no}
                                        </Table.Cell>
                                        <Table.Cell>
                                            ${receipt_amount}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                            {attachment_token ?
                                loadingFileUrl ?
                                    (
                                        <Loader active size='small' inline='centered'></Loader>
                                    )
                                    :
                                    (
                                        <Image ui={true} src={fileUrl} fluid />
                                    )
                                :
                                (
                                    <Image src={viewUrl} fluid />
                                )
                            }
                        </Segment>
                    )
                })
            }
        </div>
    );
}

export default ClaimImageDisplayReceipt;